<template>
<v-form>
  <h2>Points</h2>
<v-subheader>
Français
</v-subheader>
<v-text-field label="Nom" placeholder="Nom" outlined v-model="form.name.fr"></v-text-field>

<v-text-field label="Description" placeholder="Description" outlined v-model="form.description.fr"></v-text-field>
<v-subheader>
Anglais
</v-subheader>
<v-text-field label="Nom" placeholder="Nom" outlined v-model="form.name.en"></v-text-field>

<v-text-field label="Description" placeholder="Description" outlined v-model="form.description.en"></v-text-field>
<v-subheader>
Contacts
</v-subheader>
<div :key="key_contact" v-if="form.contact && form.contact.length > 0">
<template v-for="(m, i) in form.contact.m">
  <v-text-field :key="'contact_m_'+i" label="Email" placeholder="Email" outlined v-model="form.contact.m[i]" @click:append="delContact('m', i)" append-icon="mdi-delete"></v-text-field>
</template>
<template v-for="(m, i) in form.contact.p">
  <v-text-field :key="'contact_p_'+i" label="Téléphone" placeholder="Téléphone" outlined v-model="form.contact.p[i]" @click:append="delContact('p', i)" append-icon="mdi-delete"></v-text-field>
</template>
<template v-for="(m, i) in form.contact.w">
  <v-text-field :key="'contact_w_'+i" label="Site web" placeholder="Site web" outlined v-model="form.contact.w[i]"  @click:append="delContact('w', i)" append-icon="mdi-delete"></v-text-field>
</template>
</div>

<v-btn text @click="addContact()"><v-icon class="mr-3">mdi-account-plus</v-icon>Ajouter un contact</v-btn>
<v-subheader class="title">Localisation</v-subheader>
<template v-if="form.location.address">
<v-subheader class="subtitle-2">Adresse</v-subheader>
<v-text-field label="Pays" placeholder="Pays" outlined v-model="form.location.address.country"></v-text-field>
<v-text-field label="Commune" placeholder="Commune" outlined v-model="form.location.address.city"></v-text-field>
<v-text-field label="Code postal" placeholder="Code postal" outlined v-model="form.location.address.zipcode"></v-text-field>
<v-text-field label="n° et nom de rue" placeholder="n° et nom de rue" outlined v-model="form.location.address.streetAddress"></v-text-field>
</template>

<v-subheader class="subtitle-2">Position GPS</v-subheader>
<v-row>
 <v-col>
   <MglMap v-if="form.location"   :zoom="zoom()" :center="center()"  :accessToken="accessToken"   @load="load"   :mapStyle="mapStyle" >
     <MglGeocoderControl
     language="fr"
     placeholder="Rechercher une commune"
     :accessToken="accessToken"

    />
     <v-btn v-if="form.location.geoloc.lat==null && form.location.geoloc.lng==null" id="fabMarkerAdd" @click="addMarker" fab><v-icon>mdi-map-marker-plus</v-icon></v-btn>

     <MglMarker v-if="form.location.geoloc.lat!==null && form.location.geoloc.lng!==null" :draggable="true"  @dragend="dragend" :coordinates="coordinates()" color="blue" />
</MglMap>
 </v-col>
 <v-col>
   <v-text-field label="Latitude" placeholder="Latitude" outlined v-model="form.location.geoloc.lat"></v-text-field>
   <v-text-field label="Longitude" placeholder="Longitude" outlined v-model="form.location.geoloc.lng"></v-text-field>

 </v-col>
</v-row>
<v-subheader class="title">Jeu</v-subheader>
<v-text-field label="Valeur" placeholder="Valeur du point" outlined v-model="form.value" type="number"></v-text-field>

<v-select label="Type de validation" v-model="form.typeValidation" :items="items" outlined>

</v-select>

  <v-text-field v-if="form.typeValidation == 'gps'" label="Rayon (mètres)" placeholder="Rayon de détection (en mètres)" outlined v-model="form.range" type="number"></v-text-field>

<template v-if="form.typeValidation == 'qrcode'">
  <v-text-field outlined v-model="form.qrcodeValue" label="QRCode" placeholder="QRCode"></v-text-field>

  <v-btn @click="generateQrcodeValue()">Générer une nouvelle valeur pour le QrCode</v-btn>

  <v-btn @click="downloadQrcode()" v-if="id">Imprimer le QRCode</v-btn>
</template>


<v-btn block dark color="teal darken-2" :loading="loading" @click="wrapSubmit()">{{ actionName }}</v-btn>
</v-form>

</template>
<script>
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import MglGeocoderControl from 'vue-mapbox-geocoder'
import "mapbox-gl/dist/mapbox-gl.css";
import {  GeoFirestore } from 'geofirestore';
import firebase from '@firebase/app';
import (/* webpackChunkName: "firebase" */'@firebase/firestore');
import { MglMap, MglMarker } from "vue-mapbox";
var QRCode = require('qrcode')

export default {
  components: {  MglMap, MglMarker, MglGeocoderControl },
  props: ['form', 'actionName', 'id'],
  data: () => ({
    key_contact: 'key_0',
    loading: false,
    firestore: null,
    geofirestore: null,
    geocollection: null,
    items: ['gps', 'qrcode'],
    mapStyle: 'mapbox://styles/mapbox/streets-v11',
    accessToken: 'pk.eyJ1Ijoic2ltb241MSIsImEiOiJjamg4dGUyZXkwNmxuM2NvNmFxN2p5cnpmIn0.G4Igc5WvjFjuIQ6UcuxLOQ',
    headers:[{value: 'd.name_fr', text: 'Nom'}, {value: 'd.city', text: 'Commune'}, {value: '', text: 'Actions'}]
  }),
  created() {
    window.html2canvas = html2canvas


    this.map = null;
  },
  mounted() {

    this.firestore = firebase.firestore();
    this.geofirestore = new GeoFirestore(this.firestore);
    this.geocollection = this.geofirestore.collection('pois');
    if (!this.form.location.address) {
      this.form.location.address =  {city: '', country: 'France', streetAddress: '', zipcode: ''};
      this.$forceUpdate();
    }
  },
  computed: {
    wrapSubmit() {
      if (this.id) {
        return this.update;
      } else {
        return this.create;
      }
    }
  },
  methods: {
    downloadQrcode() {
      QRCode.toDataURL(this.id + '_' + this.form.qrcodeValue,{scale: 10}).then(url =>{
    var doc = new jsPDF();

    doc.setFont('Arial Black');
    doc.setFontSize(40);

    doc.text('Go-France',doc.internal.pageSize.getWidth()/2, 20, { align: "center" });
    doc.setFontSize(18);
  doc.setFont('Arial');

      doc.text(this.form.name_fr,doc.internal.pageSize.getWidth()/2, 40, { align: "center" } );
      doc.setFontSize(22);
    doc.addImage(url, 'JPEG', doc.internal.pageSize.getWidth()/3.5 , 90);
    doc.setFontSize(8);

    doc.text(20, doc.internal.pageSize.getHeight()-10, 'Généré le '+new Date().toLocaleDateString()+' à '+new Date().toLocaleTimeString()+'');
    doc.save(this.form.name_fr+'.pdf');
  });

    /*  var doc = new jsPDF()
      doc.html(document.getElementById('print_doc').innerHTML, {
   callback: function (doc) {
     doc.save();
   }
});
      console.log(document.getElementById('print_doc').innerHTML)*/

      //doc.save(this.form.name_fr+'.pdf');

    },
      generateQrcodeValue() {
        if (this.form.qrcodeValue == undefined) {
          this.form.qrcodeValue  = '';
        }
          if (this.form.qrcodeValue !== undefined && this.form.qrcodeValue.length > 0) {
            if(window.confirm('Il y a déjà une valeur de QRCOde êtes vous sûr de vouloir la modifier ?')){
              this.randomQrCode();
            }
          } else {
            this.randomQrCode();
          }
      },
      randomQrCode() {
        this.form.qrcodeValue = Math.random().toString(36).substr(2, 16);
        this.$forceUpdate();
      },
    addMarker() {
      let center = this.map.getCenter().toArray();
      this.form.location.geoloc.lat = center[1];
      this.form.location.geoloc.lng = center[0];
      this.form.geocoord = this.form.location.geoloc;
    },
    zoom() {
      if (this.form.location.geoloc.lat!==null && this.form.location.geoloc.lng !==null) {
        return 14;
} else {
  return 3;
}

},create() {
  this.loading = true;
  let o = this.form;
  this.form.name_fr = this.form.name.fr;
  this.form.city = this.form.location.address.city;
  const self = this;
  o.coordinates = new firebase.firestore.GeoPoint(this.form.geocoord.lat,this.form.geocoord.lng);
  this.geocollection.add(o).then((d) => {
    self.loading = false;

    self.$router.push({name:'AdminPointList', hash: '#'+d.id});
  }).catch(() => {
    self.loading = false;

  })
},
    update() {
      this.loading = true;
      this.form.name_fr = this.form.name.fr;
      if (this.form.location.address.city.length > 0){
        this.form.city = this.form.location.address.city;
      }

      if (this.form.city.length > 0) {
          this.form.location.address.city = this.form.city;
      }
      this.geocollection.doc(this.id).update(JSON.parse(JSON.stringify(this.form))).then(()=>{
          // On fait fermer
          this.loading = false;
          this.$store.dispatch('setDialogEdit', {m: false, e: 'points', data: null, id:null});

      }).catch(() => {
          this.loading = false;
      });
    },
    dragend(e) {

      this.form.location.geoloc = {lat: e.mapboxEvent.target.getLngLat().toArray()[1], lng:e.mapboxEvent.target.getLngLat().toArray()[0] };
      //console.log(e.mapboxEvent.target.getLngLat());
    },
    center() {
      if (this.form.location.geoloc.lat!==null && this.form.location.geoloc.lng !==null) {
        return {lon: this.form.location.geoloc.lng, lat: this.form.location.geoloc.lat};

      } else {

          return {lon: 2.178351, lat: 47.170703};
      }
    },
    coordinates() {
      if (this.form.location.geoloc.lat!== null && this.form.location.geoloc.lng !== null) {
        return [this.form.location.geoloc.lng, this.form.location.geoloc.lat];

      }
    },
    load(e) {
      this.map = e.map;
      setTimeout(() => {
        e.map.resize();
      }, 200);
    },
    delContact(t, i) {
      if (window.confirm('Etes-vous sûr de vouloir supprimer ce contact ?')) {
        this.form.contact[t].splice(i, 1);
        //this.form.contact[t] = this.form.contact[t].splice(i, 1);

        //this.key_contact = 'key_' + Math.floor(Math.random() * 11);
        //this.$forceUpdate();
      }
    },
    addContact() {

    }
  }

}
</script>
<style>

@import url('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.5.1/mapbox-gl-geocoder.css');

.mgl-map-wrapper {
  height: 400px;
  width: 100%;

}
.mapboxgl-map {
  overflow: visible;
  height: 100% !important;
}
</style>
